var $ = require('jquery')
  , Video = require('widgets/Video')

$(function() {
  var tabContents = $('.tab-content')
  tabContents.each(function() {
    var currentTabContent = $(this)
    var modVideo = currentTabContent.find('.mod-video')
    if (!modVideo.length) { return }

    var cover = modVideo.find('.cover')
      , videoUrl = modVideo.data('video-url')
      , playerContainer = modVideo.find('.video-player')

    currentTabContent.on('tab:hide', function() {
      cover.show()
      playerContainer.empty().hide()
    })

    cover.on('click', function() {
      cover.hide()
      var video = new Video({
        videoUrl: videoUrl
      })

      playerContainer.html(video.toHTML()).show()
    })
  })
})
